import { render } from "./Besoin.vue?vue&type=template&id=6e528d0a"
import script from "./Besoin.vue?vue&type=script&lang=js"
export * from "./Besoin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__